import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { DTANFEDMyFavoriteLibModule } from '../../../dt-an-myfavorite-lib/src/lib/dt-an-myfavorite-lib.module';


@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    DTANFEDMyFavoriteLibModule
  ],
  providers: [],
})
export class AppModule {}
